import { render, staticRenderFns } from "./ColumnPareto.vue?vue&type=template&id=c9471c1a&"
import script from "./ColumnPareto.vue?vue&type=script&lang=js&"
export * from "./ColumnPareto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports